function JSDOM(xmlString, options){
    let domParser = new DOMParser();
    let dom = domParser.parseFromString(xmlString, options.contentType);
    return {window : { document : dom } };
}

module.exports.JSDOM = JSDOM;



// WEBPACK FOOTER //
// lib/runtime/platform-bootstrap/browser/jsdom.js